module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert",
    class: _vm.classObject
  }, [(_vm.dismissible) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), _vm._t("header"), _vm._v(" "), _vm._t("body")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cac39a54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VAAlert.vue
// module id = 752
// module chunks = 0